// ORDER PAYMENT STRIPE
export const PAYMENT_STRIPE_REQUEST = 'PAYMENT_STRIPE_REQUEST';
export const PAYMENT_STRIPE_SUCCESS = 'PAYMENT_STRIPE_SUCCESS';
export const PAYMENT_STRIPE_FAIL = 'PAYMENT_STRIPE_FAIL';
